import { gql } from 'urql';

const SetAutopayForPayOverTime = gql`
  mutation SetAutopayForPayOverTime($input: SetAutopayForPayOverTimeInput!) {
    setAutopayForPayOverTime(input: $input) {
      __typename
      ... on PayOverTimeAutopaySuccess {
        autoPayEnabled
      }
      ... on PayOverTimeAutopayError {
        code
        message
        title
      }
    }
  }
`;

export default SetAutopayForPayOverTime;
